import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';  // Custom styles
import './globals.css';  // From the Next.js project
import './styles/main.css';  // From the Next.js project
import './styles/_modal.scss';
import { initThemeFromStorage } from './utils/themeColors';
import App from './App';

initThemeFromStorage();

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
